import React from "react";
import { pluralize } from "@common/helpers/string";

interface Props {
    filters: {
        accrualCoaAccounts?: string[];
        includeUnassignedAccrualAccount?: boolean;
    };
}

export const AccrualCoaAccountFilterLabel: React.FC<Props> = ({
    filters: { accrualCoaAccounts, includeUnassignedAccrualAccount },
}) => {
    const count =
        (accrualCoaAccounts?.length ?? 0) +
        (includeUnassignedAccrualAccount ? 1 : 0);

    if (count === 0) {
        return null;
    }

    if (count === 1 && includeUnassignedAccrualAccount) {
        return <>No account</>;
    }

    return (
        <>
            {count} {pluralize("Account", count)}
        </>
    );
};
